import type { ReactNode } from "react";
import { Navigate, Outlet } from "react-router";

import { useAuthStore } from "../../stores/authStore";

export function ProtectedRoute({ children }: { children?: ReactNode }) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
